// @flow
import type { Dispatch } from "redux";
import type { RaceProgram, RaceWagerType } from "@tvg/types/Race";
import { type selectionsType } from "@tvg/api/wtx";
import { get } from "lodash";
import type { TalentPickData } from "@tvg/types/TalentPicks";

import { BetStatus } from "./utils";

export type BetStatusType = "NONE" | "PLACED" | "ERROR" | "PROCESSING";

export type BetGroupStatus = {
  [key: string]: {
    status: BetStatusType
  }
};

export type BetTicketGroupStatus = {
  betGroupStatus: BetGroupStatus,
  processingBets: number,
  errorBets: number,
  successBets: number
};

export type RetrySubmitBet = {
  wagerType?: RaceWagerType,
  betSelections?: string[][],
  wagerSelection?: selectionsType,
  betAmount?: number,
  race?: RaceProgram
};

export type SetGroupBetTicketStatus = {
  type: "SET_GROUP_BET_TICKET_STATUS",
  payload: BetTicketGroupStatus
};

export type SetGroupBetTicketCountersReset = {
  type: "SET_GROUP_BET_TICKET_COUNTERS_RESET"
};

export type SetGroupBetTicketStatusClear = {
  type: "SET_GROUP_BET_TICKET_STATUS_CLEAR"
};

export type SetGroupBetTicketStop = {
  type: "SET_GROUP_BET_TICKET_STOP"
};

export type OpenVideoAction = {
  type: "VIDEO_OPEN"
};

export const setGroupBetTicketStatusAction =
  (
    betTypeCode: string,
    status: BetStatusType,
    retryBet: RetrySubmitBet,
    statusCode?: number
  ): any =>
  (dispatch: Dispatch<*>, getState: any) => {
    const betTicketState = getState().BetTicket;

    const betGroupStatus = {
      [betTypeCode]: {
        status,
        retryBet,
        statusCode
      }
    };

    const keys = Object.keys(betGroupStatus);
    let processingBets = get(betTicketState, "processingBets", 0);
    let errorBets = get(betTicketState, "errorBets", 0);
    let successBets = get(betTicketState, "successBets", 0);

    keys.forEach((key) => {
      const keyStatus = get(betGroupStatus, `${key}.status`);

      if (keyStatus === BetStatus.success) {
        successBets += 1;
        processingBets -= 1;
      } else if (keyStatus === BetStatus.error) {
        errorBets += 1;
        processingBets -= 1;
      } else {
        processingBets += 1;
      }
    });

    dispatch({
      type: "SET_GROUP_BET_TICKET_STATUS",
      payload: {
        betGroupStatus,
        processingBets,
        errorBets,
        successBets
      }
    });
  };

export const setGroupBetTicketCountersResetAction = () => ({
  type: "SET_GROUP_BET_TICKET_COUNTERS_RESET"
});

export const setGroupBetTicketStatusClearAction = () => ({
  type: "SET_GROUP_BET_TICKET_STATUS_CLEAR"
});

export const setGroupBetTicketStopAction = () => ({
  type: "SET_GROUP_BET_TICKET_STOP"
});

export const openVideoAction = () => ({
  type: "VIDEO_OPEN"
});
